const RateLimitCategories = Object.freeze({
  REALTIME_CONCURRENT: 'RealtimeConcurrent',
  CONCURRENT: 'Concurrent',
  REALTIME: 'Realtime',
  GENERAL: 'General'
})
export default RateLimitCategories
// RESERVE BELOW
